





































































import { Component, Vue } from 'vue-property-decorator';
import merchantApi from '@/api/merchant';

interface PaymentParams {
  amt: string;
  memberName: string;
  orderId: string;
  rentalScheduleId: string;
  repayType: string;
  seqId: string;
  timestamp: string;
  remark: string;
  sourceType: string;
  isLaw: string;
}

@Component({
  name: 'PaymentPage'
})
export default class PaymentPage extends Vue {
  showNoteDialog = false;
  urlParams: PaymentParams = {
    amt: '',
    memberName: '',
    orderId: '',
    rentalScheduleId: '',
    repayType: '',
    seqId: '',
    timestamp: '',
    remark:'',
    sourceType:'',
    isLaw:'',
  };

  created() {
    document.title = '账单支付';
    this.getUrlParams();
  }

  /**
   * 获取URL参数并存储到对象中
   */
  getUrlParams() {
    const queryString = window.location.search.substring(1);
    if (!queryString) return;
    const decodedString = decodeURIComponent(queryString);
    const pairs = decodedString.split('&');
    pairs.forEach(pair => {
      const [key, value] = pair.split('=');
      if (key && value && key in this.urlParams) {
        (this.urlParams as any)[key] = value;
      }
    });

    console.log('URL参数:', this.urlParams);
  }

  confirmNote() {
    this.showNoteDialog = false;
  }

  getActiveProduct() {
    if (!this.urlParams.orderId) {
      this.$toast.fail('订单号有误');
      return;
    }
    if (!this.urlParams.seqId) {
      this.$toast.fail('期次有误');
      return;
    }
    if (!this.urlParams.amt) {
      this.$toast.fail('支付金额有误');
      return;
    }
    this.$http({
      url: `${merchantApi.cashierRepayOff.url}`,
      method: merchantApi.cashierRepayOff.method,
      params: {
          orderNo: this.urlParams.orderId,
          term: this.urlParams.seqId,
          offlinePayAmt:this.urlParams.amt,
          ...this.urlParams
      },
      sourceType: this.urlParams.sourceType || ''
    }).then((res: any) => {
      if(res.code==200&&res.data.submitFormData){
        window.location.href = res.data.submitFormData;
      }

    });
  }
}
